import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useVolumeDiscountAlert } from '../../../hooks/useVolumeDiscountAlert'
import { useQuoteContext } from '../../../hooks/useQuoteContext'

/**
 * Centralized component to monitor all products for 50% volume discount threshold
 * Shows a single modal when any product crosses the threshold
 * Only shown when user has LimitVolumeDiscount permission and manually types an EE count crossing the cap
 */
export default function VolumeDiscountAlert() {
   const { showBigDeal, alertProduct, handleClose } = useVolumeDiscountAlert()
   const { getString, getFormattedString } = useQuoteContext()

   return (
      <Modal
         backdrop='static'
         keyboard={true}
         show={showBigDeal}
         onHide={handleClose}
         centered
      >
         <Modal.Header closeButton>
            <Modal.Title>
               {getString('alert.VolumeDiscountAlert.Title')}
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
            {getFormattedString('alert.VolumeDiscountAlert.Body', {
               alertProduct,
            })}
         </Modal.Body>
         <Modal.Footer>
            <Button variant='primary' onClick={handleClose}>
               {getString('alert.VolumeDiscountAlert.Button')}
            </Button>
         </Modal.Footer>
      </Modal>
   )
}
